import { render, staticRenderFns } from "./CreateFirstBusinessComponent.vue?vue&type=template&id=22888684&scoped=true&"
import script from "./CreateFirstBusinessComponent.vue?vue&type=script&lang=js&"
export * from "./CreateFirstBusinessComponent.vue?vue&type=script&lang=js&"
import style0 from "./CreateFirstBusinessComponent.vue?vue&type=style&index=0&id=22888684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22888684",
  null
  
)

export default component.exports